const state = () => ({
  //매장제품리스트 사이드 팝업
  isSideLargePrdtListPopup: false,
});

const getters = {
  getIsSideLargePopup: (state) => state.isSideLargePrdtListPopup,
};

const actions = {
  setIsSideLargePopup({ commit }, isSideLargePrdtListPopup) {
    commit('SET_IS_SIDE_LARGE_PRDT_LIST_TOGGLE', isSideLargePrdtListPopup);
  },
};

const mutations = {
  SET_IS_SIDE_LARGE_PRDT_LIST_TOGGLE(state, payload) {
    state.isSideLargePrdtListPopup = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
